export var sanitizeUrl = function (url) {
    return url.replace(/(javascript|script|vbscript)/gi, '');
};
